<div #toastList [id]="t.id" class="toast align-items-center text-white border-0" [class]="'bg-'+t.typeName" role="alert" aria-live="assertive" aria-atomic="true" *ngFor="let t of toasts">
  <div class="d-flex">
    <div class="toast-body">
      {{ t.message }}
    </div>
    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
  </div>
</div>
